"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var OverflowMenu = /*#__PURE__*/function (_Component) {
  _inherits(OverflowMenu, _Component);

  var _super = _createSuper(OverflowMenu);

  function OverflowMenu() {
    var _this;

    _classCallCheck(this, OverflowMenu);

    _this = _super.call(this);
    _this.state = {
      open: false
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onClickOutside = _this.onClickOutside.bind(_assertThisInitialized(_this));
    _this.onItemClick = _this.onItemClick.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.toggleMenu = _this.toggleMenu.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OverflowMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onClickOutside);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (e.key === " ") {
        this.onClick(e);
      }
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(event) {
      if (this.ref && !this.ref.current.contains(event.target)) {
        if (this.state.open) this.toggleMenu();
      }
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu(e) {
      var open = !this.state.open;
      this.setState({
        open: open
      });
      this.props.onMenuToggle && this.props.onMenuToggle(open);
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      e.stopPropagation();
      this.toggleMenu();
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(index, value) {
      this.props.onItemClick && this.props.onItemClick(index, value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      this.addClass("".concat(this.constructor.BASE_CLASS, "--").concat(this.props.size || 'normal'));

      var items = _react.default.Children.map(this.props.children, function (option, index) {
        return /*#__PURE__*/_react.default.cloneElement(option, {
          index: index,
          size: _this2.props.size,
          onClick: option.props.onClick || _this2.onItemClick
        });
      });

      this.props.menuAlign && this.addClass("lth-is-".concat(this.props.menuAlign, "-aligned"));
      this.state.open && this.addClass('lth-is-open');
      var containerClasses = [this.constructor.BASE_CLASS + '__container'];
      this.props.fullwidth && containerClasses.push('lth-is-fullwidth');
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClasses.join(' '),
        onClick: this.onClick,
        onKeyDown: this.onKeyDown,
        ref: this.ref
      }, this.props.target, /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames(),
        style: this.getStyle()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + '__scrollable'
      }, items)));
    }
  }]);

  return OverflowMenu;
}(_component.default);
/*---------------------------------------------*/


exports.default = OverflowMenu;

_defineProperty(OverflowMenu, "BASE_CLASS", 'lth-c-overflowmenu');

var OverflowMenuItem = /*#__PURE__*/function (_Component2) {
  _inherits(OverflowMenuItem, _Component2);

  var _super2 = _createSuper(OverflowMenuItem);

  function OverflowMenuItem() {
    _classCallCheck(this, OverflowMenuItem);

    return _super2.apply(this, arguments);
  }

  _createClass(OverflowMenuItem, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var label = this.props.label || this.props.children;
      var icon = null;

      if (this.props.icon) {
        icon = /*#__PURE__*/_react.default.createElement(_.Icon, {
          size: 16,
          icon: this.props.icon,
          className: OverflowMenu.BASE_CLASS + '__item__icon'
        }); // this.addClass('lth-has-icon');
      }

      if (this.props.selected) {
        this.addClass('lth-is-selected');
      }

      var props = {
        className: this.getClassNames(),
        style: this.getStyle(),
        tabIndex: 0,
        onClick: function onClick(e) {
          _this3.props.onClick && _this3.props.onClick(_this3.props.index, _this3.props.value);
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === " ") {
            _this3.props.onClick && _this3.props.onClick(_this3.props.index, _this3.props.value);
          }
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", props, icon, /*#__PURE__*/_react.default.createElement(_.Text, {
        size: this.props.size === 'slim' ? 'small' : 'regular'
      }, label));
    }
  }]);

  return OverflowMenuItem;
}(_component.default);

_defineProperty(OverflowMenuItem, "BASE_CLASS", OverflowMenu.BASE_CLASS + '__item');

OverflowMenuItem.METADATA = {
  name: 'OverflowMenu.Item',
  props: [{
    name: 'label',
    type: 'string',
    default: 'Label'
  }, {
    name: 'icon',
    type: 'string'
  }]
};
OverflowMenu.Item = OverflowMenuItem;
/*----*/

var OverflowMenuSeparator = /*#__PURE__*/function (_React$Component) {
  _inherits(OverflowMenuSeparator, _React$Component);

  var _super3 = _createSuper(OverflowMenuSeparator);

  function OverflowMenuSeparator() {
    _classCallCheck(this, OverflowMenuSeparator);

    return _super3.apply(this, arguments);
  }

  _createClass(OverflowMenuSeparator, [{
    key: "render",
    value: function render() {
      var props = {
        className: OverflowMenu.BASE_CLASS + '__separator'
      };
      return /*#__PURE__*/_react.default.createElement("div", props);
    }
  }]);

  return OverflowMenuSeparator;
}(_react.default.Component);

OverflowMenuSeparator.METADATA = {
  name: 'OverflowMenu.Separator'
};
OverflowMenu.Separator = OverflowMenuSeparator;
/*---------------------------------------------*/

OverflowMenu.METADATA = {
  name: 'OverflowMenu',
  description: '',
  props: [{
    name: 'target',
    type: 'jsx',
    default: '<div style="font-size: 16px">Click Me</div>'
  }, {
    name: 'size',
    type: 'string',
    default: 'normal',
    options: [{
      value: 'slim'
    }, {
      value: 'normal'
    }]
  }, {
    name: 'onItemClick',
    type: 'function',
    description: 'Callback function called when an item was clicked'
  }],
  content: {
    default: [/*#__PURE__*/_react.default.createElement(OverflowMenu.Item, {
      label: "Option 1",
      value: "value1"
    }), /*#__PURE__*/_react.default.createElement(OverflowMenu.Item, {
      label: "Option 2",
      value: "value2",
      selected: true
    }), /*#__PURE__*/_react.default.createElement(OverflowMenu.Separator, null), /*#__PURE__*/_react.default.createElement(OverflowMenu.Item, {
      icon: "settings",
      label: "Option 3",
      value: "value3"
    })]
  }
};